import Vue from 'vue'
import * as types from './mutation-types'

export default {
  [types.SWITCH_ADVANCED] (state, bol) {
    state.advancedFilter = {}
    state.normalFilter = {}
    state.advanced = bol
  },
  [types.FILTER_ADVANCED] (state, obj) {
    Vue.set(state.advancedFilter, obj.key, obj.value)
    refresh(state)
  },
  [types.FILTER_NORMAL] (state, obj) {
    Vue.set(state.normalFilter, obj.key, obj.value)
    refresh(state)
  },
  [types.SET_SORTOBJ] (state, obj) {
    state.sortObj = obj
    refresh(state)
  },
  // 重置筛选项
  [types.RESET] (state) {
    state.advanced = false
    state.advancedFilter = {}
    state.normalFilter = {}
    state.sortObj = {}
  },
  // 列表页初始化
  [types.INITLIST] (state, val) {
    state.moduleName = val
    state.advanced = false
    state.advancedFilter = {}
    state.normalFilter = {}
    state.sortObj = {}
    state.selectRows = {}
    state.selectIds = []
    state.selectPu = []
  },
  // 增加关联产品
  [types.INCREASE_SELECT] (state, obj) {
    state.selectProducts.push(obj)
  },
  // 删除关联产品
  [types.DECREASE_SELECT] (state, index) {
    state.selectProducts.splice(index, 1)
  },
  // 更新关联产品
  [types.UPDATE_SELECT] (state, arr) {
    state.selectProducts = arr
  },
  // 更新业绩目标指标列表
  [types.UPDATE_PERFORMANCE_NAV] (state, arr) {
    state.performanceNavList = arr
  },
    // 异步验证
  [types.ASYNC_VALIDATE] (state, attr) {
    state.attr = attr
  },
  // 更新选中的行
  [types.UPDATE_SELECTROWS] (state, obj) {
    if (obj.del) {
    /*
      如果obj有del属性，则代表要删除
        'all' 表示全部删除
        'string' || 'number' 表示单个字段的key
        'array' 表示删除多个值
    */
      if (obj.del === 'all') {
        state.selectRows = {}
      } else if (typeof obj.del === 'string' || typeof obj.del === 'number') {
        delete state.selectRows[obj.del]
        // 待采购移除选中的时候同事去掉state.selectPu中已选的
        if (state.moduleName === 'waitPurchaseApi') {
          state.selectPu.map((item, i) => {
            if (parseInt(item.productId) === parseInt(obj.del)) {
              state.selectPu.splice(i, 1)
            }
          })
        }
      } else {
        obj.del.forEach(item => {
          delete state.selectRows[item]
        })
      }
    } else {
      // 如果 obj.id 存在则代表取消选中，不存在即选中
      if (state.selectRows[obj.id]) {
        delete state.selectRows[obj.id]
        // 待采购列表
        if (state.moduleName === 'waitPurchaseApi') {
          state.selectPu.map((item, i) => {
            if (parseInt(item.productId) === parseInt(obj.id)) {
              state.selectPu.splice(i, 1)
            }
          })
        }
      } else {
        state.selectRows[obj.id] = obj.name
        // 待采购列表
        if (state.moduleName === 'waitPurchaseApi') {
          if (obj.productArray) {
            // 按缺货合同，不需要处理供应商
            obj.productArray.map(it => {
              let arrObj = {
                productId: it.productId,
                num: it.productNum
              }
              state.selectPu.push(arrObj)
            })
          } else {
            // 按缺货产品
            let arrObj = {
              productId: obj.id,
              num: obj.productNum,
              supplierIdList: obj.supplierIdList
            }
            state.selectPu.push(arrObj)
          }
        }
      }
    }
    udSelectIds(state)
  },
  // 全选
  [types.SELECT_ALL] (state, arr) {
    console.log('vuex', arr)
    arr.forEach(item => {
      state.selectRows[item.id] = item.name
      // 待采购列表
      if (state.moduleName === 'waitPurchaseApi') {
        let arrObj = {}
        if (item.productArray) {
          // 按缺货合同，不需要处理供应商
          item.productArray.map(it => {
            arrObj = {
              productId: it.productId,
              num: it.productNum
            }
            if (state.selectPu.findIndex((obj) => obj.productId === item.productId) === -1) {
              state.selectPu.push(arrObj)
            }
          })
        } else {
          // 按缺货产品
          arrObj = {
            productId: item.id,
            num: item.productNum,
            supplierIdList: item.supplierIdList
          }
          if (state.selectPu.findIndex((obj) => obj.productId === item.id) === -1) {
            state.selectPu.push(arrObj)
          }
        }
      }
    })
    udSelectIds(state)
  },
  // 取消全选
  [types.CANCEL_ALL] (state, arr) {
    arr.forEach(item => {
      delete state.selectRows[item.id]
      // 待采购列表
      if (state.moduleName === 'waitPurchaseApi') {
        state.selectPu.map((obj, i) => {
          if (parseInt(item.id) === parseInt(obj.productId)) {
            state.selectPu.splice(i, 1)
          }
        })
      }
    })
    udSelectIds(state)
  },
  // 详情页权限配置
  [types.DETAIL_CONFIG] (state, obj) {
    state.detailConfig = obj
  },
  // 更新消息提醒数量
  [types.UPDATE_REMINDCOUNT] (state, str) {
    if (str === 'reduce') {
      state.remindCount--
    } else if (str === 'increase') {
      state.remindCount++
    } else {
      if (str) {
        state.remindCount = str
      } else {
        state.remindCount = 0
      }
    }
  },
  // 设置服务端返回的错误码
  [types.ERROR_CODE] (state, code) {
    state.errorCode = code
  },

  // 设置列表页的loading状态
  [types.LIST_LOADING] (state, bool) {
    state.listLoading = bool
  },

  // 设置左侧菜单展开、收起状态
  [types.SIDEMENU_STATUS] (state) {
    state.sidemenuStatus = !state.sidemenuStatus
  },

  // 更新address组件数据
  [types.UPDATE_ADDRESS] (state) {
    state.updateAddress = !state.updateAddress
  },

  // 设置特殊枚举类
  [types.SPECIAL_ENMUS] (state, obj) {
    state.specialEnmus = obj
  },

  // 更新扫码数量增加所在行序号
  [types.UPDATE_ADDNUMINDEX] (state, val) {
    if (typeof val === 'number') {
      state.addNumIndex = val
    }
  },

  // 更新页码
  [types.UPDATE_VUEXPAGE] (state, obj) {
    state.vuexPageObj = obj
  },
  // 菜单自定义
  [types.SET_ALIAS_LIST] (state, val) {
    state.aliasList = val
  },
  // 刷新列表页
  [types.SET_FRESH_ALL_LIST] (state, val) {
    state.freshAllList = val
  }
}

// 更新selectIds
function udSelectIds (state) {
  state.selectIds = Object.keys(state.selectRows).map(item => Number(item))
}

// 刷新列表页
function refresh (state) {
  state.freshList = !state.freshList
}




// WEBPACK FOOTER //
// ./src/store/mutations.js